export default {"src":"/_next/static/image/public/images/ic_pending_red.9d4413d672f26b048c10461c1f479398.svg","height":18,"width":18};